import { Box, Paper, Typography } from "@mui/material";
import { SawScheduleBudget } from "../models/types";
import {
	CardBodySx,
	CardPaperSx,
	CardTitle,
	EMPTY,
	InfoGrid,
	microLabelSx,
	Unavailable,
} from "./primitives";

type Props = {
	data?: SawScheduleBudget | null;
};

const val = (v: number | null | undefined) =>
	v === null || v === undefined ? EMPTY : String(v);
const pair = (a: number | null | undefined, b: number | null | undefined) =>
	`${val(a)} / ${val(b)}`;

// "Scheduled / Budget" — the two schd/budget pairs; cycle times moved to
// their own card so this one stays two rows tall.
export const ScheduleBudgetCard = ({ data = null }: Props) => (
	<Paper elevation={1} sx={CardPaperSx}>
		<CardTitle
			title="Scheduled / Budget"
			action={<Typography sx={microLabelSx}>scheduled / budget</Typography>}
		/>

		<Box sx={CardBodySx}>
			<Unavailable
				active={
					data?.bundlesPerHrSchd == null &&
					data?.bundlesPerHrBudget == null &&
					data?.bundlesPerShiftSchd == null &&
					data?.bundlesPerShiftBudget == null
				}
			>
				<InfoGrid
					columns={1}
					items={[
						{
							label: "Finished Bundles / Hour",
							value: pair(data?.bundlesPerHrSchd, data?.bundlesPerHrBudget),
						},
						{
							label: "Finished Bundles / Shift",
							value: pair(
								data?.bundlesPerShiftSchd,
								data?.bundlesPerShiftBudget,
							),
						},
					]}
				/>
			</Unavailable>
		</Box>
	</Paper>
);
